import React from "react"
import { DeleteEventForm } from "../../../components/DeleteEventForm"

export const DeleteEventPage = () => {
  return (
    <div>
      <DeleteEventForm />
    </div>
  )
}
